import Vue from "vue";
import leadsService from "@/services/leads.service";

export const leads = {
  namespaced: true,
  state: {
    lead: {},
    leads: [],
    totalLeads: 0,
    isOpenLeadDrawer: false
  },
  getters: {},
  actions: {
    async getLeads({ commit }, payload) {
      try {
        const { leads } = await leadsService.getLeads(payload);

        commit("setLeads", leads);
      } catch (error) {
        Vue.noty.error(this.i18n.t("leads.messages.errors.get"));
      }
    },
    async getLead({ commit }, payload) {
      try {
        const { lead } = await leadsService.getLead(payload);

        commit("setLead", lead);
      } catch (error) {
        Vue.noty.error(this.i18n.t("leads.messages.errors.get"));
      }
    },
    async openLeadDrawer({ commit, dispatch }, payload) {
      commit("setLead", {});
      await dispatch("getLead", payload);
      commit("toggleLeadDetailsDrawer", true);
    }
  },
  mutations: {
    setLeads(vuexState, payload) {
      vuexState.leads = payload.data;
      vuexState.totalLeads = payload.total;
    },
    setLead(vuexState, payload) {
      vuexState.lead = payload;
    },
    toggleLeadDetailsDrawer(vuexState, payload) {
      vuexState.isOpenLeadDrawer = payload;
    }
  }
};
